module.exports = __webpack_public_path__ + "fonts/BourgeoisRounded-BoldCondensed.6ac32cbe.woff";